import { useContext } from "react";

import { analyticsEvent } from "@up/analytics";
import { CohortCartDataContext } from "@up/cart";
import { UPLink } from "@up/ui";

function formatCatalogueItemType(type) {
  switch (type) {
    case "program":
    default:
      return "Enrichment";
    case "collegeCredit":
      return "College Credit";
  }
}

export default function CohortCard({
  buttonClasses = "",
  buttonText = "Apply Now",
  showItemType = true,
}: {
  buttonClasses?: string;
  buttonText?: string;
  showItemType?: boolean;
}) {
  const context = useContext(CohortCartDataContext);

  return (
    <div
      className={`cohort-card animation-fade-in flex flex-col ${
        context.cohort.catalogueItem.type === "collegeCredit"
          ? "cohort-card-college-credit"
          : ""
      }`}
      data-element="cohort-card"
    >
      <div className="cohort-card-info flex-grow">
        <h3 className="cohort-card-dates">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              fill="#00B5E2"
              d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
            ></path>
          </svg>
          <strong>{context.cohort.formattedDateRange}</strong>
        </h3>
        {!context.isCoursePage && context.cohort.catalogueItem.name && (
          <h3 className="cohort-card-program-name">
            {context.cohort.catalogueItem.name}
          </h3>
        )}
        <p>Length: {context.cohort.cohortLength}</p>
        <p>Cost: {context.cohort.formattedRetailPrice}</p>
        {context.deadline && context.deadlineKey === "app_deadline" && (
          <p>Application Deadline: {context.deadline}</p>
        )}
        {context.deadline && context.deadlineKey === "reg_deadline" && (
          <p>Registration Deadline: {context.deadline}</p>
        )}
        {showItemType ? (
          <p>
            <strong>
              Type: {formatCatalogueItemType(context.cohort.catalogueItem.type)}
            </strong>
          </p>
        ) : null}
      </div>

      <div className="cohort-card-action flex flex-shrink-0 flex-grow">
        {context.isFull && (
          <span
            className={`cursor-not-allowed opacity-75 ${buttonClasses}`}
            data-element="cohort-card-button"
          >
            Session Full
          </span>
        )}

        {!context.isFull &&
          (context.showAddToCart ? (
            <button
              className={`up-cohort-listing-button ${buttonClasses} ${
                context.isAddingItem ? "opacity-50 cursor-wait" : ""
              }`}
              data-element="cohort-card-button"
              disabled={context.isAddingItem}
              onClick={context.addToCart}
            >
              Add to Cart
            </button>
          ) : (
            <UPLink
              className={`up-cohort-listing-button ${buttonClasses}`}
              data-element="cohort-card-button"
              href={context.url}
              onClick={() => {
                analyticsEvent({
                  event: "applyNowCourse",
                });
              }}
              prefetch={false}
            >
              {buttonText}
            </UPLink>
          ))}
      </div>
    </div>
  );
}
